"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = require("classnames");
var React = require("react");
var popup = function (props) {
    var bgImg = '/res/img/recapture-2.jpg';
    var classes = classnames_1.default([
        'l-fullscreen-dim',
        'l-fullscreen-dim--center',
        'c-recapture',
        'c-recapture--full',
        {
            'l-fullscreen-dim--active': props.recaptureProps.isActive,
            'c-recapture--active': props.recaptureProps.isActive,
        },
    ]);
    var onBgClicked = function (event) {
        if (event.currentTarget !== event.target)
            return;
        props.recaptureProps.onRecaptureCloseClicked();
    };
    return (React.createElement("div", __assign({ onClick: onBgClicked, id: "recapture", className: classes }, props.analyticId(props.recaptureProps.flavor, 'close')),
        React.createElement("div", { className: "c-recapture__main", style: { backgroundImage: "url('" + bgImg + "')" } },
            React.createElement("div", { onClick: props.recaptureProps.onRecaptureCloseClicked, className: "c-recapture__close" },
                React.createElement("span", __assign({ className: "fal fa-times" }, props.analyticId(props.recaptureProps.flavor, 'close')))),
            React.createElement("div", { className: "c-recapture__body" },
                React.createElement("div", { className: "c-recapture__title" }, props.recaptureProps.t.heading),
                React.createElement("div", { className: "c-recapture__caption" }, props.recaptureProps.t.caption),
                React.createElement("div", { className: "c-recapture__action" },
                    React.createElement("button", __assign({ id: "recapture-button", onClick: props.recaptureProps.onRecaptureSaveClicked, className: "o-btn o-btn--primary u-md" }, props.analyticId(props.recaptureProps.flavor, 'close')),
                        React.createElement("span", { className: "fal fa-bell" }),
                        props.recaptureProps.t.save))))));
};
exports.default = popup;
